import React from "react";

import { useQuery } from "@tanstack/react-query";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";

import VideoSurveyMessageService from "../../../../services/video.survey.messages.service";
import Communication from "../../../Generic/Communication";
import useLocalVideoToggle from "../../hooks/useLocalVideoToggle/useLocalVideoToggle";
import useMessages from "../../hooks/useMessages/useMessages";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import TabHeader from "../Header/TabHeader";
import useSurveyStyles from "../styles";
import useStyles from "./styles";

interface Props {
  toggle: boolean;
  actions: (value: boolean, index?: number) => void;
}

const CommunicationSection: React.FC<Props> = ({ toggle, actions }) => {
  const { t: translate } = useTranslation();
  const { isSharingScreen, room, messages, setMessages } = useVideoContext();

  const localParticipant = room?.localParticipant;
  const { sendMessage } = useMessages(localParticipant);

  const { isFetching } = useQuery(
    ["video.survey.messages", room?.name],
    () =>
      VideoSurveyMessageService.getAll({
        roomName: room?.name,
        sortBy: JSON.stringify([["sendDate", "asc"]]),
      }),
    {
      enabled: !!room?.name,
      onSuccess: (response) => {
        if (response?.data) setMessages(response.data);
      },
    }
  );

  const [isVideoEnabled] = useLocalVideoToggle();
  const surveyClasses = useSurveyStyles();
  const classes = useStyles(isVideoEnabled, isSharingScreen)();

  return (
    <div
      data-cy="communicationSection"
      className={classnames(surveyClasses.section, classes.mainSection)}
    >
      <div className="mt-2">
        <TabHeader toggle={toggle} actions={actions} />
      </div>
      <div className={classes.communicationWrapper}>
        <Communication
          loading={isFetching}
          dateFormat="hh:mm a"
          messages={messages}
          sendComment={sendMessage}
          header={
            <header className={classes.communicationHeader}>
              <span className="title">{translate("communication")}</span>
              <MdClose
                data-cy="closeCommunication"
                size={16}
                className={classes.communcationCloseIcon}
                onClick={() => actions(true)}
              />
            </header>
          }
        />
      </div>
    </div>
  );
};

export default CommunicationSection;
